// This file is auto-generated. Run `pnpm generate:icons` to regenerate.
// biome-ignore-all assist/source/organizeImports: Generated file.
// biome-ignore-all format: Generated file.
// biome-ignore-all lint/a11y/noSvgWithoutTitle: Icon accessibility is handled by the Icon wrapper.
import type { SVGProps } from "react";

export default function ChevronLeftIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 7.313 11.778 C 6.896 12.1768 6.896 12.8216 7.313 13.2162 L 16.184 21.7009 C 16.601 22.0997 17.275 22.0997 17.687 21.7009 C 18.1 21.3021 18.104 20.6573 17.687 20.2627 L 9.57 12.4992 L 17.687 4.7357 C 18.104 4.3369 18.104 3.692 17.687 3.2975 C 17.27 2.903 16.596 2.8987 16.184 3.2975 L 7.313 11.778 Z" fill="currentColor" />
</svg>
  );
}